import { state } from "../../state/workspaceStore.js";
import { nodes } from "../common/reactHelpers.jsx";
import { esc } from "../../utils/format.js";
export function historyTable(pid) {
  const rows = state.db.adjustments
    .filter((a) => a.productId === pid)
    .slice()
    .reverse();
  return rows.length ? (
    <div className={"table-wrap"}>
      <table>
        <thead>
          <tr>
            <th>{"Date"}</th>
            <th>{"SKU"}</th>
            <th>{"Stock"}</th>
            <th>{"Reason"}</th>
          </tr>
        </thead>
        <tbody>
          {nodes(
            rows.map((a) => (
              <tr>
                <td>{esc(a.date)}</td>
                <td>{esc(a.code || a.skuId)}</td>
                <td>
                  {a.before ?? "—"}
                  {" \u2192 "}
                  {a.after}
                </td>
                <td>{esc(a.reason)}</td>
              </tr>
            )),
          )}
        </tbody>
      </table>
    </div>
  ) : (
    <p className={"empty"}>{"No adjustments yet."}</p>
  );
}
